import { NotificationType } from '@shared/types/notification.types';

export interface NotificationTemplate {
  title: string;
  message: string;
  priority: 'high' | 'normal' | 'low';
}

type MessageNotificationType = Pick<
  Record<NotificationType, NotificationTemplate>,
  NotificationType.NEW_MESSAGE
>;

export const NOTIFICATION_TEMPLATES: MessageNotificationType = {
  [NotificationType.NEW_MESSAGE]: {
    title: 'New Message',
    message: 'You have received a new message from {actor}',
    priority: 'normal',
  },
};
